export default __webpack_public_path__ + "static/media/Amtrak_Stations.b0e1c1c0.geojson";